import React, { useCallback, useState } from 'react';
import { AiOutlineUser } from 'react-icons/ai';
import { FiChevronDown } from 'react-icons/fi';
import {
  HStack,
  VStack,
  Text,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Center,
  Checkbox,
  Box,
  Icon,
  Spinner,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
} from '@chakra-ui/react';
import {
  api,
  clearGlobalData,
  clearUser,
  setDivisions,
  useAppDispatch,
  useAppSelector,
  useSetBaseMutation,
} from '@spartalabs/pdc-core';

export const HeaderMenu = () => {
  const dispatch = useAppDispatch();
  const {
    user: { groups, name, abbreviation, currentDivisionId, currentGroupId },
  } = useAppSelector(state => state.authSlicer);

  const [setBase, { isLoading }] = useSetBaseMutation();

  const [bases, setBases] = useState<string[] | undefined>(
    currentDivisionId ? currentDivisionId.split(',') : undefined,
  );

  const [group, setGroup] = useState<string | undefined>(
    currentGroupId ? currentGroupId : undefined,
  );

  const handleSetBase = useCallback(async () => {
    try {
      await setGroup(group);
      await setBase(bases ? bases : []);
      dispatch(api.util.resetApiState());

      await dispatch(
        setDivisions({
          bases: bases && bases.length > 0 ? bases.join(',') : '',
          group: group || '',
        }),
      );
    } catch (error) {
      /* empty */
    }
  }, [bases]);
  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        data-cy="user"
        py={2}
        transition="all 0.3s"
        _focus={{ boxShadow: 'none' }}
      >
        <HStack mr="32px">
          <VStack
            mr="16px"
            display={{ base: 'none', xl: 'flex' }}
            alignItems="flex-start"
            spacing="1px"
          >
            <Text isTruncated color="white" fontSize="sm">
              {name}
            </Text>
            <Text isTruncated fontSize="xs" color="gray.300">
              {abbreviation}
            </Text>
          </VStack>
          <Center
            display={{ base: 'none', xl: 'flex' }}
            border="0.5px solid white"
            w="20px"
            h="20px"
            borderRadius="16px"
          >
            <Icon as={FiChevronDown} color="white" />
          </Center>
        </HStack>
        <Box display={{ base: 'flex', xl: 'none' }}>
          <AiOutlineUser size={18} />
        </Box>
      </MenuButton>
      <MenuList
        zIndex="dropdown"
        bg="button"
        sx={{
          '&::-webkit-scrollbar': {
            borderRadius: '8px',
            backgroundColor: 'ocean.100',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'ocean.200',
          },
        }}
        maxHeight="90vh"
        overflowY="auto"
      >
        <Accordion
          maxWidth="300px"
          allowToggle
          borderColor="transparent"
          defaultIndex={[0]}
        >
          {groups?.map(division => (
            <AccordionItem key={division.groupId}>
              <AccordionButton>
                {division.groupDivision.length > 1 ? (
                  <Text> {division.groupName}</Text>
                ) : (
                  <Checkbox
                    isChecked={division.groupId === group}
                    onChange={() => {
                      setGroup(division.groupId);
                      setBases([division.groupDivision[0].divisionId]);
                    }}
                  >
                    {division.groupName}
                  </Checkbox>
                )}

                {division.groupDivision.length > 1 && (
                  <AccordionIcon ml="8px" />
                )}
              </AccordionButton>

              {division.groupDivision.length > 1 &&
                division.groupDivision.map(item => (
                  <AccordionPanel bg="ocean.100" key={item.divisionId}>
                    <Checkbox
                      isChecked={bases?.includes(item.divisionId)}
                      onChange={e => {
                        if (group !== division.groupId) {
                          setGroup(division.groupId);
                          setBases([item.divisionId]);
                        } else if (e.target.checked) {
                          setBases(prev =>
                            prev
                              ? [...prev, item.divisionId]
                              : [item.divisionId],
                          );
                        } else {
                          setBases(prev =>
                            prev
                              ? prev.filter(value => value !== item.divisionId)
                              : undefined,
                          );
                        }
                      }}
                    >
                      {item.divisionName}
                    </Checkbox>
                  </AccordionPanel>
                ))}
            </AccordionItem>
          ))}
        </Accordion>

        <MenuItem
          onClick={handleSetBase}
          bg="button"
          justifyContent={isLoading ? 'center' : 'start'}
        >
          {isLoading ? (
            <Spinner
              alignSelf="center"
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="ocean.200"
              size="sm"
            />
          ) : (
            <Text>Alterar Base</Text>
          )}
        </MenuItem>
        <MenuDivider />

        <HStack>
          <MenuItem
            onClick={() => {
              dispatch(clearUser());
              dispatch(clearGlobalData());
              dispatch(api.util.resetApiState());
            }}
            bg="button"
          >
            Sair
          </MenuItem>
        </HStack>
      </MenuList>
    </Menu>
  );
};
